import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
export default class TaskApproved extends React.Component {
  localizedData = [
    { text: "Yes", value: true },
    { text: "No", value: false },
  ];
  componentDidMount = () => {
    if (
      this.props.dataItem.inEdit &&
      document.getElementById("taskapprovedId")
    ) {
      document.getElementById("taskapprovedId").focus();
    }
  };
  handleChange = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value.value,
    });
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      let updateData = {
        ...this.props.dataItem,
        [this.props.field]: e.target.value.value,
      };
        this.props.updateDropdownValue(updateData);
    }
  };

  handleEditCell = () => {
    if(this.props.dataItem.isClosed===false || this.props.dataItem.isClosed==="Open"){
      this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };

  render() {
    const { dataItem, field } = this.props;
    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    if (field && dataItem.inEdit === field) {
      return (
        <td>
        <DropDownList
          style={{ width: "100px" }}
          onChange={this.handleChange}
          value={this.localizedData.find((c) => c.value === dataValue)}
          data={this.localizedData}
          textField="text"
          id="taskapprovedId"
          disabled={this.props.dataItem.isClosed === "Closed" ? true : false}
        />
        </td>
      );
    }
    if (dataItem.inEdit !== field) {
      return this.props.dataItem.roleName == "Standard User" ||
        this.props.dataItem.roleName == "View Only" ? (
        <td>
          {dataValue.toString() === "true" || dataValue.toString() === "Yes"
            ? "Yes"
            : "No"}
        </td>
      ) : (
        <td onClick={this.handleEditCell}>
          {dataValue.toString() == "true" || dataValue.toString() === "Yes"
            ? "Yes"
            : "No"}
        </td>
      );
    }
  }
}
